import { t } from '@unistocks/shared/localization/index.ts';
import { Stack } from 'expo-router';

export const unstable_settings = {
  anchor: 'index'
};

export default function AssetLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: 'transparent' }
      }}
    >
      <Stack.Screen name="[assetId]/index" options={{ title: t('::Asset') }} />
    </Stack>
  );
}
